"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setHttp = setHttp;
exports.setHttpMethod = setHttpMethod;
exports.setHttpListener = setHttpListener;
exports.setFileDomain = setFileDomain;
exports.setFileDomainListener = setFileDomainListener;
exports.httpMethod = exports.http = void 0;

var _fieldType = require("../fieldType");

var http = null;
exports.http = http;
var httpMethod = 'post'; // 订阅存储 当设置了 http 的方法时 调用订阅方法

exports.httpMethod = httpMethod;
var httpListeners = []; // domain 订阅存储

var fileDomainListeners = [];
/**
 * 设置发送请求方法
 * @param h
 */

function setHttp(h) {
  exports.http = http = h;
  httpListeners.forEach(function (func) {
    func(h);
  });
}

function setHttpMethod(method) {
  exports.httpMethod = httpMethod = method;
}

function setHttpListener(func) {
  if (http) {
    func(http);
  }

  httpListeners.push(func);
}

function setFileDomain(d) {
  _fieldType.FieldType.setFileDomain(d);

  fileDomainListeners.forEach(function (func) {
    func(d);
  });
}

function setFileDomainListener(func) {
  if (_fieldType.fileDomain) {
    func(_fieldType.fileDomain);
  }

  fileDomainListeners.push(func);
}